const status = 1; //1正式  2测试

// const testUrl = 'http://8.141.80.116';
const testUrl = 'http://192.168.110.164:9999';
const baseUrl = "/shfwmini"

const socketUrl = 'ws://quzhu.quzhu123.cn:2346';


const ossUrl = baseUrl + '/api/common/OSSFileUpload';

const fwSaveUrl = baseUrl + '/api/common/fileUpload';

const mapKey = '6c9fec5fe51a0580bbfa909048157102';

const mapKeyFW = '6c9fec5fe51a0580bbfa909048157102';


export default {
	status,
	baseUrl, //api接口域名
	ossUrl,
	process: process.env.NODE_ENV_TYPE,
	mapKey,
	mapKeyFW,
	socketUrl,
	fwSaveUrl
}